import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { AsyncFormValidation } from '../../interceptors/error.interceptor';
import { AssignConsumableAsset, ConsumableAsset, ConsumableAssetDTO } from '../../models/consumableasset.interface';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { RequestService } from '../request/request';
import { QueryGet } from '../../types/query-types';
import { Pagination } from '../../models/pagination.interface';
import { OptionSelect } from '../../../shared/components/search-select/search-select';

@Injectable({
  providedIn: 'root',
})
export class ConsumableassetService {
  httpOptions = {
    headers: new HttpHeaders({}),
  };

  urlPath = environment.service_1 + 'consumable-assets/';
  url = environment.service_1 + 'all-consumable-assets/';

  urlAdd = environment.service_1 + 'assign-activity-consumable/';
  urlUpdateAdd = environment.service_1 + 'update-assign-activity-consumable/';
  urlDelete = environment.service_1 + 'delete-assign-activity-consumable/';

  public asyncErrorValidation = new BehaviorSubject<AsyncFormValidation | null>(null);
  asyncErrorValidation$ = this.asyncErrorValidation.asObservable();

  private selectedConsumableAsset = new BehaviorSubject<ConsumableAsset | null>(null);
  selectedConsumableAsset$ = this.selectedConsumableAsset.asObservable();

  private ConsumableAssets = new BehaviorSubject<ConsumableAsset[]>([]);
  ConsumableAssets$ = this.ConsumableAssets.asObservable();

  constructor(
    private http: HttpClient,
    private requestService: RequestService,
  ) {}

  setConsumableAsset(consumableAsset: ConsumableAsset) {
    this.selectedConsumableAsset.next(consumableAsset);
  }

  setConsumableAssets(consumableAssets: ConsumableAsset[]) {
    this.ConsumableAssets.next(consumableAssets);
  }

  removeConsumableAssetSelected() {
    this.selectedConsumableAsset.next(null);
  }

  createConsumableAsset(consumableAsset: ConsumableAssetDTO) {
    return this.http.post<ConsumableAsset>(this.urlPath, consumableAsset).pipe(
      tap({
        error: (err: HttpErrorResponse) => {
          this.asyncErrorValidation.next(err.error);
        },
      }),
    );
  }

  UpdateConsumableAsset(id: number, consumableAsset: ConsumableAssetDTO & { id: number }) {
    return this.http.put<ConsumableAsset>(this.urlPath + id + '/', consumableAsset).pipe(
      tap({
        error: (err: HttpErrorResponse) => {
          this.asyncErrorValidation.next(err.error);
        },
      }),
    );
  }

  getConsumableAsset(query: QueryGet): Observable<Pagination<ConsumableAsset[]>> {
    return this.requestService.get<ConsumableAsset[]>(this.urlPath, query);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(this.urlPath + id + '/');
  }

  getConsumableAssets(): Observable<ConsumableAsset[]> {
    return this.http.get<ConsumableAsset[]>(this.url, {
      headers: this.httpOptions.headers,
    });
  }

      addConsumableAsset(consumableAsset: AssignConsumableAsset) {
        return this.http.post(this.urlAdd, consumableAsset).pipe(
          tap({
            error: (err: HttpErrorResponse) => {
              this.asyncErrorValidation.next(err.error);
            },
          }),
        );
      }

      updateAddConsumableAsset(id: number, consumableAsset: AssignConsumableAsset & { id: number }) {
        return this.http.put(this.urlUpdateAdd + id + '/', consumableAsset).pipe(
          tap({
            error: (err: HttpErrorResponse) => {
              this.asyncErrorValidation.next(err.error);
            },
          }),
        );
      }

        deleteAssignConsumableAsset(id: number): Observable<void> {
    return this.http.delete<void>(this.urlDelete + id + '/');
  }

  getOptionConsumableAsset(component: ConsumableAsset[]): OptionSelect[] {
    return component.map((item: ConsumableAsset) => {
      return {
        value: item.id ?? '',
        label: item.name,
      };
    });
  }
}
